const About = () => {
  return (
    <>
      <title>NM | About</title>

      <div className="boxed-content">
        <div className="title-bar">
          <h1>About Niuniu Media</h1>
        </div>
        <div className="about-section">
          <h2>About</h2>
          <p>Niuniu Media is a self-hosted YouTube media server. Download and manage your favorite YouTube channels, playlists and videos.</p>
        </div>
      </div>
    </>
  );
};

export default About;
